import {
  addCurrentAuthHeader,
  type SessionService,
} from '@efdigital/ll-addon-auth';
import type { Apis } from '@efdigital/ll-addon-auth/types/apis';
import config from '@efdigital/ll-admin-v2/config/environment';

const apis: Apis = config['ll-addon-auth-apis'];

export type UserInfo = {
  id: string;
  title: string;
  lastLogin?: string;
  created?: string;
};

export async function buildGetUsersByUserId(
  query: {
    clientId?: string;
    includeDeleted: boolean;
    id: string[];
  },
  session: SessionService
) {
  const init = await addCurrentAuthHeader(
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: query.id,
        includeDeleted: query.includeDeleted,
      }),
    },
    { session }
  );

  return new Request(
    `${apis.monolithApi.host}/management-api/dashboard/${encodeURIComponent(query.clientId || 'global')}/users/search`,
    init
  );
}

export async function buildSearchUsersByEmail(
  query: {
    clientId?: string;
    emails: string[];
  },
  session: SessionService
) {
  const init = await addCurrentAuthHeader(
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ emails: query.emails }),
    },
    { session }
  );

  return new Request(
    `${apis.monolithApi.host}/management-api/dashboard/${encodeURIComponent(query.clientId || 'global')}/users/search`,
    init
  );
}

export async function buildSearchUsersByText(
  query: {
    clientId?: string;
    text: string;
  },
  session: SessionService
) {
  const init = await addCurrentAuthHeader(
    {
      method: 'GET',
    },
    { session }
  );

  return new Request(
    `${apis.monolithApi.host}/management-api/dashboard/${encodeURIComponent(query.clientId || 'global')}/users/search?search=${encodeURIComponent(query.text)}`,
    init
  );
}

const emailRegex =
  /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;

export function isValidEmail(str: string) {
  return emailRegex.test(str || '');
}
